import React, { useEffect, useState } from 'react';
import datasheet2 from "src/assets/images/icon-datasheet-2.png"
import DisplayLifeCycleRisk from 'src/component/custom/DisplayLifeCycleRisk';
import DisplayQtyMinQtyMult from 'src/component/custom/DisplayQtyMinQtyMult';
import PriceTable from 'src/component/custom/PriceTable';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import NavigateToProductDetail from "../../../component/custom/NavigateToProductDetail";
import $ from "jquery";
import "floating-scroll";
import { useProductStore } from 'src/hooks/product';
import CustomerPartNumberOptions from 'src/component/custom/CustomerPartNumberOptions';
import noImage from 'src/assets/images/noimage.png'
import ReusableDiv from 'src/helper/ReusableDiv';
import { useCartStore } from 'src/hooks/cart';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';


const AlternativeBomPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props
    const [alternateData, setAlternateData] = useState({ alternateProductData: [], alternateManufacturerData: [], alternateInventoryData: [], alternateTypeData: [], alternateKeyAry: [] })
    const [{ }, { get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { add_part_to_bom, swap_part_number, create_params_for_add_part_to_bom }] = useBOMStore();
    const [{ alternative_product_data, productList }, { fetch_alternative_product_by_variant_number_list, get_product_assets }, { clear_alternative_product_data }] = useProductStore();
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();

    const selected_product = data && data.selected_product

    useEffect(() => {
        SetStatus(true)
        async function fetchHere() {
            if (data) {
                await getAlternativeProductByVariantNumber()

                setTimeout(() => {
                    $(".alternate-table").floatingScroll("init");
                }, 1000)
            }
        }
        fetchHere()
    }, [data]);

    const onHide = (action = true) => {
        clear_alternative_product_data()
        SetStatus(false)
    };

    useEffect(() => {
        async function fetchHere() {
            await getProductData()
        }

        fetchHere()
    }, [alternative_product_data]);

    useEffect(() => {
        let product = alternative_product_data.value
        if (product && Object.keys(product).length > 0) {

            let alternateProductDataHere = []
            let alternateManufacturerData = []
            let alternateInventoryData = []
            let alternateTypeData = []
            let keyAry = getAttrKeys();
            keyAry = keyAry.map(obj => ({ key: obj, value: [] }))

            Object.keys(product).map((v, i) => (
                alternateProductDataHere.push({
                    "ERPPartNumber": product[v].ERPPartNumber,
                    "ItemNumber": product[v].ItemNumber,
                    "ManufacturerPartNumber": product[v].ManufacturerPartNumber,
                    "DatasheetUrl": product[v].DatasheetUrl || '#',
                    "QtyMin": product[v].QtyMin,
                    "QtyMult": product[v].QtyMult,
                    "LifeCycleRisk": product[v].LifeCycleRisk,
                    "CustomerPartNumbers": (product[v].CustomerPartNumbers && Array.isArray(product[v].CustomerPartNumbers) && product[v]?.CustomerPartNumbers.length > 0 ? product[v].CustomerPartNumbers : null),
                    "ERPMFRPartNumber": product[v].ERPMFRPartNumber,
                    "ManufacturerName": product[v].ManufacturerName
                }),

                alternateManufacturerData.push({
                    "ManufacturerName": product[v].ManufacturerName
                }),

                alternateInventoryData.push({
                    "ItemNumber": product[v].ItemNumber
                }),

                alternateTypeData.push({
                    "Type": product[v].Type
                }),
                keyAry.forEach((k, idx) => {
                    const attr = product[v].Attributes.find(f => f.ATTRNAME === k.key)?.ATTRVAL;
                    k.value.push(attr ? attr : "NA");
                })
            ))
            setAlternateData({
                ...alternateData,
                alternateProductData: alternateProductDataHere,
                alternateManufacturerData: alternateManufacturerData,
                alternateInventoryData: alternateInventoryData,
                alternateTypeData: alternateTypeData,
                alternateKeyAry: keyAry
            })
        }
    }, [alternative_product_data]);

    const getAlternativeProductByVariantNumber = async () => {
        await fetch_alternative_product_by_variant_number_list({ ItemNum: selected_product.itemNumber })
    }

    const onSwapHandler = async (selectedProductToSwap) => {
        let params = {}
        params.partNumber = selectedProductToSwap.ERPMFRPartNumber;
        params.itemNumber = selectedProductToSwap.ItemNumber;
        params.erpPartNumber = selectedProductToSwap.ERPPartNumber;
        params.manufacturerPartNumber = selectedProductToSwap.ERPMFRPartNumber;
        params.quantity = selectedProductToSwap.QtyMin
        params.LifeCycleRisk = selectedProductToSwap.LifeCycleRisk ? selectedProductToSwap.LifeCycleRisk : ''
        params.bomDetailId = selected_product.bomDetailId
        params.bomId = selected_product.bomId
        params.customerPartNumber = CART_BEFORE_TO_SEND_SERVER[selectedProductToSwap.ItemNumber]?.CPN || ""
        params.designWinFlag = selected_product?.designWinFlag

        let swapPartRes = await swap_part_number(params)
        if (swapPartRes?.data) {
            await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(params.bomId)
            onHide()
        }
    }

    const onAddPartHandler = async (selectedProductToAdd) => {
        let params = await create_params_for_add_part_to_bom({ ...selectedProductToAdd, bomIds: [selected_product.bomId] })

        let addPartRes = await add_part_to_bom(params)
        if (addPartRes?.data) {
            await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(selected_product.bomId)
            onHide()
        }
    }

    const getProductData = async () => {
        await get_product_assets(alternative_product_data.value)
    }
    const getDisplayStatusOfCustomerPartNumber = (selected_prod, alternative) => {
        if (selected_prod?.product?.CustomerPartNumbers &&
            Array.isArray(selected_prod.product.CustomerPartNumbers) &&
            selected_prod.product?.CustomerPartNumbers.length > 0) {
            return true;
        }
        if (alternative &&
            Array.isArray(alternative) &&
            alternative.filter(x => x.CustomerPartNumbers !== null).length > 0) {
            return true;
        }
        return false;
    }

    const getAttrKeys = () => {
        let product = alternative_product_data?.value
        let keyAry = [];
        if (product && Object.keys(product).length > 0) {
            Object.keys(product).map(
                (v, i) => {
                    const attr = product[v].Attributes.map(f => f.ATTRNAME)
                    if (keyAry?.length > 0) {
                        keyAry = keyAry.concat(attr)
                    } else {
                        keyAry = attr
                    }
                })
        }

        keyAry = [...new Set(keyAry)];

        return keyAry;
    }
    return (
        <>
            <div className="avnet-modal avnet-modal-right bom-alternative-modal">
                <div className="avnet-modal-inner">
                    <button type="button" className="close pt-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title text-center font-24" id="myModalLabel">Alternatives</h4>
                    </div>
                    {__check(['Bom_Alternative_API_CALL'], { overlay: true }).render}
                    <div className="modal-body">
                        <div className="copmare-product-page">
                            {
                                productList && Object.keys(productList).length > 0 ?
                                    <>
                                        <div className="">
                                            <div className="table-responsive sticky-table-wrapper">
                                                {
                                                    <table
                                                        className="alternate-table copmare-product-table sticky-table table table-bordered table-striped w-auto mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th className="alternative-column-width current-selected"
                                                                    style={{ background: '#72777D' }}>CURRENTLY SELECTED
                                                                </th>
                                                                {alternateData.alternateManufacturerData.map((v, i) => (
                                                                    <th className="alternative-column-width">ALTERNATIVE {(i + 1)}</th>
                                                                ))}
                                                            </tr>
                                                            <tr className="bg-white">
                                                                <th className="alternative-column-width">
                                                                    {selected_product &&
                                                                        <div className="compare-product-detail">
                                                                            <div className="compare-product-title">
                                                                                <NavigateToProductDetail data={{ SEOManufacturerName: productList[selected_product.ItemNumber]?.SEOManufacturerName, SEOERPMFRPartNumber: productList[selected_product.ItemNumber]?.SEOERPMFRPartNumber, ItemNumber: selected_product.ItemNumber, ERPPartNumber: selected_product.ERPPartNumber }}>
                                                                                    {productList[selected_product.ItemNumber]?.ERPMFRPartNumber}
                                                                                </NavigateToProductDetail>
                                                                            </div>
                                                                            <div className="copmare-product-info">
                                                                                <div className="product-img text-center">
                                                                                    <img src={productList[selected_product.ItemNumber]?.AssetURL ? productList[selected_product.ItemNumber]?.AssetURL : noImage} />
                                                                                </div>
                                                                                <div className="sect-row">
                                                                                    {(productList[selected_product.ItemNumber]?.DatasheetUrl) ?
                                                                                        <div className="datasheet flex-1">
                                                                                            <a className="datasheet-align img-text"
                                                                                                rel="nofollow"
                                                                                                title={productList[selected_product.ItemNumber]?.ManufacturerPartNumber + " Datasheet"} target="_new">
                                                                                                <img src={datasheet2} />
                                                                                                Datasheet
                                                                                            </a>
                                                                                        </div>
                                                                                        :
                                                                                        ReusableDiv.dataSheetTooltip()
                                                                                    }
                                                                                    <div className="datasheet flex-1">
                                                                                        <span className="lifecycle low-risk"
                                                                                            aria-hidden="true"
                                                                                            data-toggle="tooltip"
                                                                                            data-placement="bottom"
                                                                                            data-html="true"
                                                                                            data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                                                                        ><DisplayLifeCycleRisk
                                                                                                single_product={productList[selected_product.ItemNumber]}
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                            <div
                                                                                className="min-max-data text-black-stone font-normal font-10 my-2">
                                                                                <DisplayQtyMinQtyMult
                                                                                    single_product={productList[selected_product.ItemNumber]}
                                                                                />
                                                                            </div>
                                                                            {__check(['BOM_SWAP_PART_NUMBER_API_CALL']).render}
                                                                            {!__check(['BOM_SWAP_PART_NUMBER_API_CALL']).status &&
                                                                                <button className="bs5 btn btn-secondary w-100"
                                                                                    onClick={() => onHide()}>Keep part
                                                                                </button>
                                                                            }
                                                                        </div>
                                                                    }
                                                                </th>
                                                                {alternateData.alternateProductData.map((v, i) => (
                                                                    <th className="alternative-column-width" key={i}>
                                                                        <div className="compare-product-detail">
                                                                            <div className="compare-product-title">
                                                                                <NavigateToProductDetail data={{ SEOManufacturerName: productList[v.ItemNumber]?.SEOManufacturerName, SEOERPMFRPartNumber: productList[v.ItemNumber]?.SEOERPMFRPartNumber, ItemNumber: v.ItemNumber, ERPPartNumber: v.ERPPartNumber }}>
                                                                                    {v.ERPMFRPartNumber}
                                                                                </NavigateToProductDetail>
                                                                            </div>
                                                                            <div className="copmare-product-info">
                                                                                <div className="product-img text-center">
                                                                                    <img src={productList[v.ItemNumber]?.AssetURL ? productList[v.ItemNumber]?.AssetURL : noImage} />
                                                                                </div>
                                                                                <div className="sect-row">
                                                                                    {v !== undefined &&
                                                                                        v.DatasheetUrl &&
                                                                                        <div className="datasheet flex-1">
                                                                                            <a className="datasheet-align img-text"
                                                                                                rel="nofollow"
                                                                                                href={v.DatasheetUrl}
                                                                                                title={v.ManufacturerPartNumber + " Datasheet"} target="_new">
                                                                                                <img src={datasheet2} />
                                                                                                <span className="blue text">
                                                                                                    Datasheet
                                                                                                </span>
                                                                                            </a>
                                                                                        </div>
                                                                                    }
                                                                                    <div className="datasheet flex-1">
                                                                                        <span className="lifecycle low-risk"
                                                                                            aria-hidden="true"
                                                                                            data-toggle="tooltip"
                                                                                            data-placement="bottom"
                                                                                            data-html="true"
                                                                                            data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                                                                        ><DisplayLifeCycleRisk
                                                                                                single_product={v}
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                            <div
                                                                                className="min-max-data text-black-stone font-normal font-10 my-2">
                                                                                <DisplayQtyMinQtyMult
                                                                                    single_product={v}
                                                                                />
                                                                            </div>
                                                                            <div className='bs5 row g10'>
                                                                                <div className='col-6'>
                                                                                    {__check(['BOM_SWAP_PART_NUMBER_API_CALL']).render}
                                                                                    {!__check(['BOM_SWAP_PART_NUMBER_API_CALL']).status &&
                                                                                        <button className="bs5 btn btn-primary w-100"
                                                                                            onClick={() => onSwapHandler(v)}>Swap Part
                                                                                        </button>
                                                                                    }
                                                                                </div>
                                                                                <div className='col-6'>
                                                                                    {__check(['BOM_SWAP_PART_NUMBER_API_CALL']).render}
                                                                                    {!__check(['BOM_SWAP_PART_NUMBER_API_CALL']).status &&
                                                                                        <button className="bs5 btn btn-secondary w-100"
                                                                                            onClick={() => onAddPartHandler(v)}>Add Part
                                                                                        </button>
                                                                                    }
                                                                                </div>
                                                                            </div>


                                                                        </div>
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={0}><b>Manufacturer</b></td>
                                                                {
                                                                    alternateData.alternateManufacturerData.map((v, i) => (
                                                                        <td></td>
                                                                    ))
                                                                }
                                                            </tr>
                                                            <tr>
                                                                <td className="alternative-column-width">
                                                                    {productList[selected_product.ItemNumber]?.ManufacturerName}
                                                                </td>
                                                                {
                                                                    alternateData.alternateManufacturerData.map((v, i) => (
                                                                        <td key={i}>{v.ManufacturerName}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                            <tr>
                                                                <td><b>Availability</b></td>
                                                                {alternateData.alternateManufacturerData.map((v, i) => (
                                                                    <td></td>
                                                                ))}
                                                            </tr>
                                                            <tr>
                                                                <td className="alternative-column-width">
                                                                    <ProductInventoryDisplay
                                                                        single_product={productList[selected_product.ItemNumber]}
                                                                        single_product_inventory={get_inventory_by_id(selected_product.ItemNumber)}
                                                                    />
                                                                </td>
                                                                {alternateData.alternateInventoryData.map((v, i) => (
                                                                    <td className="alternative-column-width" key={i}>
                                                                        <ProductInventoryDisplay
                                                                            single_product={productList[v.ItemNumber]}
                                                                            single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                                                        />
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                            <tr className={getDisplayStatusOfCustomerPartNumber(selected_product, alternateData.alternateProductData) ? '' : 'd-none'}>
                                                                <td><b>Customer Part Number</b></td>
                                                                {alternateData.alternateManufacturerData.map((v, i) => (
                                                                    <td></td>
                                                                ))}
                                                            </tr>
                                                            <tr className={getDisplayStatusOfCustomerPartNumber(selected_product, alternateData.alternateProductData) ? 'compared-product-price' : 'compared-product-price d-none'}>
                                                                <td className="alternative-column-width">
                                                                    <CustomerPartNumberOptions single_product={productList[selected_product.ItemNumber]} />
                                                                </td>
                                                                {alternateData.alternateManufacturerData.map((v, i) => (
                                                                    <td key={v} className="alternative-column-width">
                                                                        <CustomerPartNumberOptions single_product={v} />
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                            <tr>
                                                                <td><b>Price</b></td>
                                                                {alternateData.alternateManufacturerData.map((v, i) => (
                                                                    <td></td>
                                                                ))}
                                                            </tr>
                                                            <tr className="compared-product-price">
                                                                <td className="alternative-column-width">
                                                                    <PriceTable
                                                                        isDisplayCPN={false}
                                                                        force_display_pricing_table="yes"
                                                                        single_product_pricing_list={get_pricing_by_id({ uniqueId: selected_product.bomDetailId })}
                                                                        single_product_inventory={get_inventory_by_id(selected_product.ItemNumber)}
                                                                        single_product={productList[selected_product.ItemNumber]}
                                                                    />
                                                                </td>
                                                                {alternateData.alternateProductData.map((v, i) => (
                                                                    <td key={v} className="alternative-column-width">
                                                                        <PriceTable
                                                                            isDisplayCPN={false}
                                                                            force_display_pricing_table={'yes'}
                                                                            single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                                                                            single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                                                            single_product={v}
                                                                        />
                                                                    </td>
                                                                ))}
                                                            </tr>

                                                            {alternateData.alternateKeyAry.length > 0 &&
                                                                alternateData.alternateKeyAry.map((attrRow) => (
                                                                    <React.Fragment key={attrRow.key}>
                                                                        <tr>
                                                                            <td colSpan={1}><b>{attrRow.key}</b></td>
                                                                            {alternateData.alternateManufacturerData.map((_, i) => (
                                                                                <td key={`alt-key-header-${attrRow.key}-${i}`}></td>
                                                                            ))}
                                                                        </tr>

                                                                        <tr>
                                                                            <td>
                                                                                {
                                                                                    productList[selected_product.ItemNumber]?.Attributes
                                                                                        .find(attr => attr.ATTRNAME === attrRow.key)?.ATTRVAL || "NA"
                                                                                }
                                                                            </td>
                                                                            {attrRow.value.map((val, idx) => (
                                                                                <td key={`attr-val-${attrRow.key}-${idx}`}>{val}</td>
                                                                            ))}
                                                                        </tr>
                                                                    </React.Fragment>
                                                                ))
                                                            }


                                                        </tbody>


                                                    </table>
                                                }
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <AxiosIndicatorRunTimeLoader />
                            }
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default AlternativeBomPopup;